// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { logOT } from '@shared/loggingShared'
import { RewardsPlanCTO, RewardsPlanCTOAction, RewardsPlanCTOActionEnum } from '@shared/RewardsPlanCTO'
import { EthAddr } from '@shared/SchemaTypes'
import axios from 'axios'
import { User } from 'oidc-client-ts'

export async function fetchRewardsPlan(
  serverApiBaseUrl: string,
  restAPIKey: string,
  _cognitoUser: User | undefined,
  poolAddr?: EthAddr,
  accountAddr?: EthAddr
): Promise<RewardsPlanCTO[]> {
  let url = `${serverApiBaseUrl}/rewardsPlan`
  if (poolAddr && accountAddr) {
    url = `${url}?poolAddr=${poolAddr}&accountAddr=${accountAddr}`
  } else if (poolAddr) {
    url = `${url}?poolAddr=${poolAddr}`
  } else if (accountAddr) {
    url = `${url}?accountAddr=${accountAddr}`
  }
  const resultList = await axios.get(url, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })
  logOT.info(fetchRewardsPlan.name, { resultList })
  return resultList.data.results || []
}

export async function saveRewardsPlan(
  serverApiBaseUrl: string,
  restAPIKey: string,
  cognitoUser: User,
  rewardsPlan: RewardsPlanCTO
): Promise<RewardsPlanCTO[]> {
  const url = `${serverApiBaseUrl}/rewardsPlanAction`

  const rewardsPlanCTOAction: RewardsPlanCTOAction = {
    rewardsPlan: rewardsPlan,
    action: RewardsPlanCTOActionEnum.SAVE,
  }

  const config = {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
      Authorization: `Bearer ${cognitoUser.access_token}`,
    },
  }
  try {
    const r = await axios.post(url, rewardsPlanCTOAction, config)
    const data = r.data
    logOT.info(saveRewardsPlan.name, { data, rewardsPlanCTOAction })
    return data.results
  } catch (error) {
    logOT.error(saveRewardsPlan.name, 'error', { error })
    throw error
  }
}
